























































































import { EventBus } from "@/event-bus";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import InformationCard from "@/components/InformationCard.vue";
import InformationCardValues from "@/components/InformationCardValues.vue";
import { AZNCONNECT_API } from "@/services/aznconnect-api";
import { Getter } from "vuex-class";
import { ApplicationConfiguration } from "@/types/store";
import moment from "moment";

@Component({
  components: {
    "information-card": InformationCard,
    "information-card-values": InformationCardValues,
  },
})
export default class RequestConsentDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;

  @Prop({ default: null })
  referral!: any;

  @Getter("applicationConfiguration")
  applicationConfiguration!: ApplicationConfiguration;

  @Watch("value")
  onDialogVisibilityChanged(value: boolean): void {
    if (value && this.referral) {
      // Dialog is opened and referral is available.
      this.patientBSN = this.referral.PatientBSN;
      this.patientBirthDate = moment(this.referral.PatientBirthDate).format(
        "DD-MM-YYYY",
      );
    }
  }

  loading: boolean = false;
  patientBSN: string = "";
  patientBirthDate: string = "";
  requestReason: string = "";
  formValid: boolean = false;

  get show(): boolean {
    return this.value;
  }

  set show(value: boolean) {
    this.$emit("input", value);
  }

  closeDialog(): void {
    this.show = false;
    this.clearForm();
  }

  validateForm(): void {
    this.formValid = this.patientBSN !== "" && this.patientBirthDate !== "";
  }

  clearForm(): void {
    this.patientBSN = "";
    this.patientBirthDate = "";
    this.requestReason = "";
    this.formValid = false;
  }

  sendConsentRequest(): void {
    if (!this.formValid) {
      return;
    }

    this.loading = true;

    AZNCONNECT_API.post("/Mitz/RequestConsent", {
      PatientId: this.referral.PatientId,
      PatientBSN: this.patientBSN,
      PatientBirthdate: this.patientBirthDate,
      RequestReason: this.requestReason,
    })
      .then(response => {
        this.loading = false;
        EventBus.$emit(
          "application_message_component_success",
          "Toestemming is succesvol geregistreerd, er wordt nu een nieuwe professionele samenvatting opgevraagd.",
        );
        this.$emit("consentRequested");
        this.closeDialog();
      })
      .catch(error => {
        this.loading = false;
        EventBus.$emit(
          "application_message_component_error",
          "Er is een fout opgetreden bij het aanvragen van toestemming.",
        );
        this.closeDialog();
      });
  }
}
